import { useEffect, useRef, useState } from "react";
import usePriceStyles from "../Price/style";
import useStyles from "./styles";
import { Link, useHistory, useLocation } from "react-router-dom";
import { Box } from "@mui/material";
import FbIcon from "../../assets/icons/fb-contained-icon.svg";
import IgIcon from "../../assets/icons/ig-contained-icon.svg";
import InIcon from "../../assets/icons/in-contained-icon.svg";
import SuccessFullPurchase from "../../assets/images/purchases-response-images/SuccessfullPurchase.png";
import UnSuccessFullPurchase from "../../assets/images/purchases-response-images/FailedPurchase.png";
import {
  getAmeriaPaymentInfo,
  getIdramPaymentInfo,
} from "../../store/slicers/payment";
import { useDispatch } from "react-redux";
import Spinner from "../../shared/ui/components/Spinner";
import Cookies from "js-cookie";
import { hasUniqueID } from "../../shared/helpers/preOrder";

const PurchaseResult = (): JSX.Element => {
  const [success, setSuccess] = useState<boolean>();
  const [loaded, setLoaded] = useState<boolean>(false);
  const styles = useStyles();
  const classes = usePriceStyles();
  const history = useHistory();
  const location = useLocation<any>();
  const dispatch = useDispatch<any>();
  const paperRef = useRef<any>(null);

  const redirectMainPage = () => {
    if (hasUniqueID()) {
      Cookies.remove("uniqueId");
    }
    history.push("/");
  };

  const queryParser = (str: string) => {
    let search = location.search.substring(1);
    return JSON.parse(
      '{"' +
        decodeURI(search)
          .replace(/"/g, '\\"')
          .replace(/&/g, '","')
          .replace(/=/g, '":"') +
        '"}'
    );
  };

  const IdramResponseQueryParser = (str: string) => {
    let pairs = str.substring(1).split("&");
    let obj: any = {};
    let pair = [];
    let i = "";

    for (i in pairs) {
      if (pairs[i] === "") continue;

      pair = pairs[i].split("=");
      obj[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
    }

    return obj;
  };

  useEffect(() => {
    setTimeout(() => {
      window.history.forward();
    }, 0);
    window.onunload = function () {
      return null;
    };
  }, [location.pathname]);
  useEffect(() => {
    if (paperRef?.current) {
      window.scrollTo({
        behavior: "smooth",
        top: paperRef?.current?.offsetTop - 50,
      });
    }
  }, [loaded]);

  useEffect(() => {
    if (location.search) {
      if (!location.search.includes("EDP_BILL_NO")) {
        const params = queryParser(location.search);

        dispatch(
          getAmeriaPaymentInfo({
            order: params.orderID,
            paymentID: params.paymentID,
          })
        )
          .then((res: any) => {
            console.log(res, "res");
            if (res?.payload?.paymentSuccess) {
              setSuccess(res.payload.paymentSuccess);
            } else {
              setSuccess(false);
            }
          })
          .finally(() => setLoaded(true));
      } else {
        const params = IdramResponseQueryParser(location.search);
        dispatch(getIdramPaymentInfo(params?.EDP_BILL_NO))
          .then((res: any) => {
            if (res.payload.success) {
              setSuccess(res.payload.success);
            } else {
              setSuccess(false);
            }
          })
          .finally(() => setLoaded(true));
      }
    }
  }, [dispatch, location.search]);

  return (
    <div ref={paperRef}>
      {!loaded ? (
        <div className={styles.spinnerWrapper}>
          <Spinner size={50} />
        </div>
      ) : (
        <div className={styles.root}>
          <Box>
            <div className={styles.imgArea}>
              <img
                alt="success"
                src={success ? SuccessFullPurchase : UnSuccessFullPurchase}
              />
            </div>
            <p className={styles.title}>
              {success
                ? "Նամակն ընդունված է, շնորհակալություն"
                : "Նամակի գրանցման խնդիր առաջացավ"}
            </p>
            {success ? (
              <p className={styles.subtitle}>
                Դուք կստանաք էլեկտրոնային հաղորդագրություն պատվերի վերաբերյալ:
              </p>
            ) : (
              <div className={styles.tryAgainTxt}>
                <Link to="/">Խնդրում ենք կրկին փորձել</Link>
              </div>
            )}
            <button className={classes.prevBtn} onClick={redirectMainPage}>
              Գլխավոր էջ
            </button>
            {success && (
              <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                marginTop="35px"
              >
                <a
                  href="https://www.linkedin.com/company/haypostofficial"
                  className={styles.icon}
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={InIcon} alt="linkedin" />
                </a>
                <a
                  href="https://www.facebook.com/haypost.am"
                  className={styles.icon}
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={FbIcon} alt="facebook" />
                </a>
                <a
                  href="https://www.instagram.com/haypost.official/"
                  className={styles.icon}
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={IgIcon} alt="instagram" />
                </a>
              </Box>
            )}
          </Box>
        </div>
      )}
    </div>
  );
};

export default PurchaseResult;
